// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__1BGHY","spin":"Loader_spin__1X-nh"};